@if (showContextMenu) {
  <cx-context-menu [value]="shape" [options]="shapeOptions"/>

  <ng-container *ngTemplateOutlet="shapeTemplate" />
} @else {
  <ng-container *ngTemplateOutlet="shapeTemplate" />
}

<ng-template #shapeTemplate>
  <div
    class="full-height full-width shape"
    (contextmenu)="contextMenuComponent ? open($event): null"
    (mouseenter)="onmouseenter()"
    (mouseleave)="onmouseleave()"
  >
    <ng-template #shapeTooltip>
      <div class="shape-tooltip">
        <span class="shape-tooltip-content">
          {{ dataObject.ruleTipText | formatText: dataObject }}
        </span>
      </div>
    </ng-template>

    @if (shape?.image === 1 && !isForNewCashApp) {
      <ng-container *ngTemplateOutlet="imageOne" />
    }

    @if (hasError) {
      <div class="error-container">
        <i class="ri-alert-line"></i>
      </div>
    }

    @if (isForNewCashApp) {
      <div
        class="full-height full-width new-shape editable-clip-path"
        [style.transform]="dataObject?.rotate ? 'rotate(' + dataObject?.rotate + 'deg)' : 'none'"
        [style.background-image]='shape | svgToBase64Bg : (dataObject.seatStatusId === seatStatuses.BLOCKED ? blockedSeatColor : backgroundColor)'
      ></div>
    }

    @if (!isForNewCashApp) {
      @for (polygon of (shape?.polygonPoints | pointsToPolygon); track polygon) {
        <div
          class="full-width full-height position-absolute editable-clip-path"
          [style.transform]="dataObject?.rotate ? 'rotate(' + dataObject?.rotate + 'deg)' : 'none'"
          [style.background-color]="dataObject.seatStatusId === seatStatuses.BLOCKED ? blockedSeatColor : backgroundColor"
          [style.clip-path]="polygon"
          data-color
        ></div>
      }
    }

    @if (textRectPoint && !shape?.image && !isForNewCashApp) {
      <ng-container *ngTemplateOutlet="textContainerTemplate; context: { rectPoint: textRectPoint, rule: dataObject.ruleTitle }" />
    }

    @if (infoText1RectPoint && !isForNewCashApp) {
      <ng-container *ngTemplateOutlet="textContainerTemplate; context: { rectPoint: infoText1RectPoint, rule: dataObject.ruleTopText }" />
    }

    @if (infoText2RectPoint && !isForNewCashApp) {
      <ng-container *ngTemplateOutlet="textContainerTemplate; context: { rectPoint: infoText2RectPoint, rule: dataObject.ruleBottomText }" />
    }
  </div>
</ng-template>

<ng-template #imageOne>
  <div
    class="shape-icon wheelchair"
    [style.left]="shape?.imageX + '%'"
    [style.top]="shape?.imageY + '%'"
  >
    <i class="ri-wheelchair-line"></i>
  </div>
</ng-template>

<ng-template #textContainerTemplate let-rectPoint="rectPoint" let-rule="rule">
  <div
    #textContainer
    class="text-container pointer-events-none"
    [style.inset]="rectPoint.top + '% ' + (100 - rectPoint.right) + '% ' + (100 - rectPoint.bottom) + '% ' + rectPoint.left + '%'"
    [style.--character-count]="(rule | formatText: dataObject)?.length ?? 0"
    [attr.data-rect-number]="rectPoint.rectNumber"
  >
    <div
      class="text"
      data-text-container
    >
      {{ rule | formatText: dataObject }}
    </div>
  </div>
</ng-template>

<cx-context-submenu menuClass="shape-submenu" #addToTheRowSubmenu [options]="shapeSubmenuOptions"/>
